const getHeaders = () => ({
  uid: localStorage.getItem('uid'),
  'access-token': localStorage.getItem('token'),
  Authorization: localStorage.getItem('Authorization'),
  client: localStorage.getItem('client'),
})

export default getHeaders
